import React from 'react';
import { Col, FormLabel, InputGroup, Row } from 'react-bootstrap';
import Button from '../../components/Button';
import Checkbox from '../../components/Checkbox/Checkbox';
import Switch from '../../components/Switch/Switch';

const Controls = () => (
  <Row className="styles-section" id="controls">
    <Col xs={12}>
      <h3>Controls</h3>
    </Col>
    <Col xs={12}>
      <form onSubmit={(e) => {
        e.preventDefault();
      }}>
        <InputGroup className="mb-3">
          <Checkbox name="check1" threeState defaultStatus='checked'/>
          <FormLabel>
            Three states Checkbox
          </FormLabel>
        </InputGroup>

        <InputGroup className="mb-3">
          <Checkbox name="check1"/>
          <FormLabel>
            Two states Checkbox
          </FormLabel>
        </InputGroup>

        <InputGroup className="mb-3">
          <Checkbox aria-label="Checkbox disabled" disabled defaultStatus="undetermined" />
          <FormLabel aria-label="Text input with checkbox">
              Disabled checkbox
          </FormLabel>
        </InputGroup>

        <InputGroup className="mb-3">
          <input type="radio" id="radio1" name="radio1" value="1"/>
          <FormLabel htmlFor="radio1">
              Radio
          </FormLabel>
        </InputGroup>
        <InputGroup className="mb-3">
          <input type="radio" id="radio2" name="radio1" value="2"/>
          <FormLabel htmlFor="radio2">
              Radio
          </FormLabel>
        </InputGroup>

        <InputGroup className="mb-3">
          <input type="radio" disabled name="radio2"/>
          <FormLabel>
              Disabled radio
          </FormLabel>
        </InputGroup>

        <InputGroup className="mb-3">
          <input type="radio" disabled checked name="radio2"/>
          <FormLabel>
              Disabled checked radio
          </FormLabel>
        </InputGroup>

        <InputGroup className="mb-3">
          <Switch/>
          <FormLabel>
              Switch
          </FormLabel>
        </InputGroup>

        <InputGroup className="mb-3">
          <Switch disabled checked />
          <FormLabel>
              Disabled checked Switch
          </FormLabel>
        </InputGroup>

        <InputGroup className="mb-3">
          <Switch disabled />
          <FormLabel>
              Disabled Switch
          </FormLabel>
        </InputGroup>

        <Button type="submit" variant="secondary"> Submit </Button>
      </form>

    </Col>


  </Row >
);

export default Controls;